<ng-container class="w-full h-full" *ngIf="hotelInfoSummery?.FAQs">
  <h2 class="!text-lg font-bold">سوالات متداول</h2>
  <div class="faq-wrapper w-full">
    <mat-accordion [multi]="true" class="!px-0 !mt-0" hideToggle>
      <div
        class="filters-sidebar-accordion !text-black w-full flex flex-col !p-0 !m-0">
        <mat-expansion-panel *ngFor="let faq of hotelInfoSummery.FAQs"
          class="w-full" #faqPanel>
          <mat-expansion-panel-header class="!px-0">
            <div class="flex justify-between items-center w-full">
              <div class="flex justify-center items-center">
                <mat-panel-title>
                  <h3 class="text-black-900 text-sm lg:text-base font-normal">
                    {{ faq.Title }}
                  </h3>
                </mat-panel-title>
              </div>
              <div class="flex justify-center items-center text-black-200">
                <div *ngIf="!faqPanel.expanded">
                  <i class="text-3xl ico-Down"></i>
                </div>
                <div *ngIf="faqPanel.expanded">
                  <i class="text-3xl ico-Up"></i>
                </div>
              </div>
            </div>
          </mat-expansion-panel-header>
          <!-- <ng-container *ngIf="faqPanel.expanded"> -->
          <div
            [@expandAccordionPanel]="faqPanel.expanded ? 'visible' : 'hidden'"
            class="text-right p-3 text-black-300" [innerHTML]="faq.Description">
          </div>
          <!-- </ng-container> -->
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>
</ng-container>
